import React from "react";
import imageUrl from "utils/imageUrl";
import { Link } from "react-router-dom";

function Platform() {
  return (
    //   <!-- ==== platform section start ==== -->
    <>
      <section className="platform section__space pos__rel over__hi">
        <div className="container">
          <div className="platform__area">
            <div className="row d-flex align-items-center">
              <div className="col-lg-6">
                <div className="content">
                  <h5>We're Changing The Way You Invest</h5>
                  <h2>
                    The Convenience You’d Expect from a Modern Investment
                    Platform
                  </h2>
                  <p>
                    Invest and manage your portfolio through our easy-to-use
                    website and mobile app. Track your performance and watch as
                    properties across the country are acquired, improved, and
                    operated via dynamic asset updates.
                  </p>
                  <Link to="/buy" className="button button--effect">
                    Invest Now
                  </Link>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="platform__thumb thumb__ltr d-none d-lg-block">
                  <img
                    src={imageUrl("home/hero-illustration.png")}
                    alt="Platform"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="market section__space over__hi">
        <div className="container">
          <div className="market__area">
            <div className="row d-flex align-items-center">
              <div className="col-lg-6 col-xl-5">
                <div className="market__thumb thumb__rtl column__space">
                  <img
                    src={imageUrl("home/market-illustration.png")}
                    alt="Explore the Market"
                  />
                </div>
              </div>
              <div className="col-lg-6 col-xl-6 offset-xl-1">
                <div className="content">
                  <h5 className="neutral-top">
                    Real exposure to the real estate market
                  </h5>
                  <h2>You Invest. Revest Does the Rest</h2>
                  <p>
                    Transparent Real Estate Investing Through Revest.Join us and
                    experience a smarter,better way to invest in real estate
                  </p>
                  <a href="properties.html" className="button button--effect">
                    Start Exploring
                  </a>
                  <img src={imageUrl("home/market-arrow.png")} alt="Go to" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
}

export default Platform;
